import styles from "./QuickStatsBar.module.css";

export function QuickStatsBar({ tasksToday, weather }) {
  return (
    <div className={styles.bar}>
      <span>📋 {tasksToday} task{tasksToday === 1 ? "" : "s"} today</span>
      {weather && (
        <span>
          {weather.summary}, {Math.round(weather.temperatureF)}°F at nearest site
        </span>
      )}
    </div>
  );
}
